import { useMemo } from 'react'
import { Stack, styled, Typography } from '@mui/material'
import { formatClock } from '$func/date'
import { dateDayFormatter } from '$func/time'

const CenteredStack = styled(Stack)`
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
`

export function DateWrapper({
  date,
  children,
}: {
  date: number
  children: JSX.Element | JSX.Element[]
}) {
  const { day, time } = useMemo(
    () => ({
      day: dateDayFormatter.format(new Date(date)),
      time: formatClock(new Date(date)),
    }),
    [date],
  )

  return (
    <Stack direction="row" sx={{ width: '100%', height: 'fit-content' }}>
      <CenteredStack sx={{ width: '45px' }}>
        <Typography color="gray" variant="body2">
          {day}
        </Typography>
      </CenteredStack>

      {children}

      <CenteredStack sx={{ width: '60px' }}>
        <Typography color="gray" variant="caption1">
          {time}
        </Typography>
      </CenteredStack>
    </Stack>
  )
}
